import { Zrm_ConversationParticipant } from '../types/GraphqlTypes';
import stringUtils from './stringUtils';

type GetParticipantsNamesArgs = {
  activeParticipantsInConversation: Array<Zrm_ConversationParticipant>;
  referenceName: string;
};

type GetPhoneLeadParticipantDisplayArgs = {
  name: string;
  phoneNumber: string;
  formattedPhoneNumberPrefix?: string;
  shouldFormatPhoneNumber?: boolean;
};

const conversationUtils = {
  isConversationSpamOrArchived: ({ isSpam, isArchived }: ConversationStatus): boolean => isSpam || isArchived,

  // Returns string with primary participant + numerical count of additional participants
  // ex) Rachel Green +3
  getParticipantsNameWithCount: ({
    activeParticipantsInConversation,
    referenceName,
  }: GetParticipantsNamesArgs): string => {
    const totalNumParticipants = activeParticipantsInConversation.length;
    if (totalNumParticipants < 2) {
      return referenceName;
    }

    return `${referenceName} +${totalNumParticipants - 1}`;
  },

  getPhoneLeadParticipantDisplay: ({
    name,
    phoneNumber,
    formattedPhoneNumberPrefix,
    shouldFormatPhoneNumber = false,
  }: GetPhoneLeadParticipantDisplayArgs): string => {
    if (name) {
      return name;
    } else if (phoneNumber) {
      if (shouldFormatPhoneNumber) {
        const formattedPhoneNumber = stringUtils.getFormattedPhoneNumber(phoneNumber);
        return formattedPhoneNumber
          ? `${formattedPhoneNumberPrefix ? formattedPhoneNumberPrefix : ''}${formattedPhoneNumber}`
          : 'Unknown Caller';
      }

      return phoneNumber;
    }

    return 'Unknown Caller';
  },
};

export default conversationUtils;
